import { DotTypes } from "../types";

export default {
  dots: "dots",
  randomDots: "random-dots",
  rounded: "rounded",
  verticalLines: "vertical-lines",
  horizontalLines: "horizontal-lines",
  classy: "classy",
  classyRounded: "classy-rounded",
  square: "square",
  extraRounded: "extra-rounded"
} as DotTypes;
